var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { MasterRepository } from '@/models/Master/MasterRepository';
import { PrefectureIdAndNameModel } from './AreaForm';
import { Clusters } from '@/models/Menu/Constants';
var TemporaryGeoGenomeMenuSettingFormModel = /** @class */ (function () {
    function TemporaryGeoGenomeMenuSettingFormModel(item) {
        if (item === void 0) { item = {}; }
        var _a = item, id = _a.id, _b = _a.orderDescription, orderDescription = _b === void 0 ? {} : _b;
        var _c = orderDescription, _d = _c.clusterIds, clusterIds = _d === void 0 ? [] : _d, _e = _c.prefecture, prefecture = _e === void 0 ? [] : _e, _f = _c.memo, memo = _f === void 0 ? '' : _f;
        this.id = id;
        this.clusterIdAndNames = [];
        this.prefectureIdAndNames = [];
        this.orderDescription = {
            clusterIds: clusterIds,
            prefecture: prefecture,
            memo: memo,
        };
    }
    TemporaryGeoGenomeMenuSettingFormModel.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var prefectureList;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, MasterRepository.fetchPrefectureList({
                            countryId: 1,
                        })];
                    case 1:
                        prefectureList = _a.sent();
                        this.prefectureIdAndNames = this.orderDescription.prefecture.map(function (prefectureId) {
                            var prefecture = prefectureList.find(function (prefecture) { return prefecture.id === parseInt(prefectureId); });
                            return PrefectureIdAndNameModel.assign({
                                id: prefecture === null || prefecture === void 0 ? void 0 : prefecture.id,
                                name: prefecture === null || prefecture === void 0 ? void 0 : prefecture.name,
                            });
                        });
                        this.clusterIdAndNames = this.orderDescription.clusterIds.map(function (clusterId) {
                            var targetCluster = Clusters.find(function (cluster) { return cluster.id === clusterId; });
                            return ClusterIdAndNameModel.assign({
                                id: targetCluster.id,
                                name: targetCluster.name,
                            });
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(TemporaryGeoGenomeMenuSettingFormModel.prototype, "isSimulatable", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    return TemporaryGeoGenomeMenuSettingFormModel;
}());
export { TemporaryGeoGenomeMenuSettingFormModel };
var ClusterIdAndNameModel = /** @class */ (function () {
    function ClusterIdAndNameModel(item) {
        if (item === void 0) { item = {}; }
        var _a = item, id = _a.id, _b = _a.name, name = _b === void 0 ? '' : _b;
        this.id = id;
        this.name = name;
    }
    ClusterIdAndNameModel.assign = function (item) {
        return new ClusterIdAndNameModel(item);
    };
    return ClusterIdAndNameModel;
}());
export { ClusterIdAndNameModel };
